import { FETCH_ALL_JOBS, FETCH_JOB } from "../types";
import fetchService from "../../../services/fetchService";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchJobsData = (page) => async (dispatch) =>
  await dispatch({
    type: FETCH_ALL_JOBS,
    message: `All jobs data`,
    payload: fetchService(`${baseUrl.backend}/api/jobs?page=${page}`),
  });

export const fetchJobData = (id) => async (dispatch) =>
  await dispatch({
    type: FETCH_JOB,
    message: `All job data`,
    payload: fetchService(`${baseUrl.backend}/api/jobs/${id}`),
  });
